import React from 'react';
import Footer from '../Fotter';

function RefundReturn() {
    return (
        <div>
            <div className="container mx-auto px-4 py-6">
                <h2 className="text-4xl font-semibold text-center text-gray-800 mb-6">Refund & Return</h2>

                <h3 className="text-2xl font-medium text-gray-800 mb-4">Refund Policy:</h3>
                <p className="text-lg text-gray-700 mb-6">
                    Refund will be done through online mode in 5-6 working days.
                </p>

                <h3 className="text-2xl font-medium text-gray-800 mb-4">Refund can be claimed on:</h3>
                <ol className="list-decimal pl-5 space-y-4 text-lg text-gray-700">
                    <li>Non-delivered products: Non-delivered can be considered after 7 working days of expected delivery date.</li>
                    <li>Wrong product delivered: Difference on model number, color, making year, brand name will be considered.</li>
                    <li>Damaged or non-working product delivered: Full unboxing video required.</li>
                </ol>

                <h3 className="text-2xl font-medium text-gray-800 mb-4">Refund Can’t be claimed:</h3>
                <ol className="list-decimal pl-5 space-y-4 text-lg text-gray-700">
                    <li>If order not cancelled before dispatch of product.</li>
                    <li>If delivered on time and complaint of damaged or wrong product not received within 2 working days of receiving.</li>
                    <li>If wrong delivery address given and not changed before dispatch.</li>
                    <li>If order not received at given address.</li>
                </ol>

                <h3 className="text-2xl font-medium text-gray-800 mb-4">Order Cancellation:</h3>
                <ol className="list-decimal pl-5 space-y-4 text-lg text-gray-700">
                    <li>Order cancellation can be accepted in any circumstance if cancelled before dispatch.</li>
                    <li>Order cancellation can’t be accepted in any circumstance if order dispatched.</li>
                    <li>Customer can’t cancel the order before Launch Date.</li>
                </ol>

                <h3 className="text-2xl font-medium text-gray-800 mb-4">Refund Process:</h3>
                <ol className="list-decimal pl-5 space-y-4 text-lg text-gray-700">
                    <li>Refund will be processed through online mode in 5-6 working days after we receive the returned product in the same condition we deliver.</li>
                    <li>Refund will be processed after 7 working days of coupon/offer expiration date if order placed through coupons so it can ensure the coupon will not be used any further after order cancellation.</li>
                    <li>% of refunded amount will vary according to product and its category.</li>
                </ol>

                <h3 className="text-2xl font-medium text-gray-800 mb-4">Return Policy:</h3>
                <ol className="list-decimal pl-5 space-y-4 text-lg text-gray-700">
                    <li>Products can be returned if complaint registered within 24 hours after receiving product.</li>
                    <li>We try and deliver orders within 10 working days after launch.</li>
                </ol>

                <p className="text-lg text-gray-700 mt-6">
                    fliptwirls reserves all rights to cancel order and raise full refund without sharing reason.
                </p>
            </div>
            <Footer />
        </div>
    )
}

export default RefundReturn;
